"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cart = void 0;
var cart = require("@shopify/theme-cart");
require("whatwg-fetch");
var axios_1 = require("axios");
var Cart = /** @class */ (function () {
    function Cart() {
        var _this = this;
        this.context = null;
        this.cart = null;
        this.init = function (context, data) {
            _this.context = context;
        };
        this.triggerPaymentButtons = function () {
            // @ts-ignore
            window.Shopify.StorefrontExpressButtons.initialize();
        };
        /**
         * TODO: I have switched this to use axios because there were caching issues on older versions of
         * Safari (v11.1). It would make sense to switch all requests to use axios but I haven't done so
         * far as I do not have time to test the other requests are still working.
         */
        this.getCartJSON = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get("/cart?view=json&x=" + Math.random(), {
                            headers: {
                                "Content-Type": "application/json;",
                                "Cache-Control": "no-cache",
                                cache: "no-cache"
                            }
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        this.context.update({ cart: data });
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.addItem = function (id, qty, properties) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.addItem(id, __assign({ quantity: qty }, properties))];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_ITEM_ADDED_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1.status == 422) {
                            this.context.update({
                                message: "CART_ITEM_ADDED_QTY_NOT_AVAILABLE",
                                error: err_1.message
                            });
                        }
                        else {
                            this.context.update({
                                message: "CART_ITEM_ADDED_FAILED",
                                error: err_1.message
                            });
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.addItems = function (items) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all(items.map(function (item) {
                                return _this.cart.addItem(item.id, __assign({ quantity: item.qty }, item.properties));
                            }))];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_ITEM_ADDED_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        if (err_2.status == 422) {
                            this.context.update({
                                message: "CART_ITEM_ADDED_QTY_NOT_AVAILABLE",
                                error: err_2.message
                            });
                        }
                        else {
                            this.context.update({
                                message: "CART_ITEM_ADDED_FAILED",
                                error: err_2.message
                            });
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.removeItem = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.removeItem(key)];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_ITEM_REMOVED_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        this.context.update({
                            message: "CART_ITEM_REMOVED_FAILED",
                            error: err_3.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.updateQty = function (key, qty) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.updateItem(key, { quantity: qty })];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_QTY_UPDATE_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        this.context.update({
                            message: "CART_QTY_UPDATE_FAILED",
                            error: err_4.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.updateProperties = function (key, properties) { return __awaiter(_this, void 0, void 0, function () {
            var response, _a, _b, _c, _d, err_5;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 3, , 4]);
                        _b = (_a = this.cart).updateItem;
                        _c = [key];
                        _d = {};
                        return [4 /*yield*/, this.cart.getItem(key)];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([(_d.quantity = (_e.sent()).quantity,
                                _d.properties = properties,
                                _d)]))];
                    case 2:
                        response = _e.sent();
                        this.context.update({ message: "CART_PROPERTIES_UPDATE_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _e.sent();
                        this.context.update({
                            message: "CART_PROPERTIES_UPDATE_FAILED",
                            error: err_5.message
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.updateVariant = function (key, id, qty) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.cart.addItem(id, { quantity: qty })];
                    case 1:
                        response = _a.sent();
                        if (!response.id) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cart.removeItem(key)];
                    case 2:
                        response = _a.sent();
                        this.context.update({ message: "CART_VARIANT_UPDATE_SUCCESS" });
                        this.getCartJSON();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_6 = _a.sent();
                        this.context.update({
                            message: "CART_VARIANT_UPDATE_FAILED",
                            error: err_6.message
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.getCart = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.getState()];
                    case 1:
                        response = _a.sent();
                        this.context.update({ cart: response });
                        return [3 /*break*/, 3];
                    case 2:
                        err_7 = _a.sent();
                        this.context.update({
                            message: "CART_REQUEST_FAILED",
                            error: err_7.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.updateNote = function (note) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.updateNote(note)];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_NOTE_UPDATE_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_8 = _a.sent();
                        this.context.update({
                            message: "CART_NOTE_UPDATE_FAILED",
                            error: err_8.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.clearNote = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.clearNote()];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_NOTE_CLEARED_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_9 = _a.sent();
                        this.context.update({
                            message: "CART_NOTE_CLEARED_FAILED",
                            error: err_9.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.clearCart = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cart.clearItems()];
                    case 1:
                        response = _a.sent();
                        this.context.update({ message: "CART_CLEARED_SUCCESS" });
                        this.getCartJSON();
                        return [3 /*break*/, 3];
                    case 2:
                        err_10 = _a.sent();
                        this.context.update({
                            message: "CART_CLEARED_FAILED",
                            error: err_10.message
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getShippingRates = function (country, postcode) { return __awaiter(_this, void 0, void 0, function () {
            var location, query;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLocationFromPostcode(country, postcode)];
                    case 1:
                        location = _a.sent();
                        query = Object.entries(location)
                            .map(function (_a) {
                            var key = _a[0], val = _a[1];
                            return "shipping_address[" + key + "]=" + val;
                        })
                            .join("&");
                        try {
                            fetch("/cart/shipping_rates.json?" + query, {
                                credentials: "same-origin",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json;"
                                },
                                method: "GET"
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                console.log(data.shipping_rates);
                                _this.context.update({
                                    shipping: data.shipping_rates,
                                    message: "SHIPPING_RATES_SUCCESS"
                                });
                            });
                        }
                        catch (err) {
                            this.context.update({
                                message: "SHIPPING_RATES_FAILED",
                                error: err.message
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.getLocationFromPostcode = function (country, postcode) { return __awaiter(_this, void 0, void 0, function () {
            var response, json, province;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("https://maps.google.com/maps/api/geocode/json?components=country%3a" + country + "%7Cpostal_code:" + postcode + "&sensor=false&key=AIzaSyBENtlgyD5Y42WNwjbjseWLoI09ITT6UwI")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (json.status !== "OK")
                            this.context.update({
                                message: "SHIPPING_RATES_FAILED",
                                error: "failed location lookup"
                            });
                        if (!json.results.length)
                            this.context.update({
                                message: "SHIPPING_RATES_FAILED",
                                error: "no locations found"
                            });
                        province = json.results[0].address_components
                            .filter(function (address) {
                            return address.types.includes("administrative_area_level_1");
                        })
                            .map(function (address) { return address.short_name; });
                        if (!province)
                            this.context.update({
                                message: "SHIPPING_RATES_FAILED",
                                error: "no province found"
                            });
                        return [2 /*return*/, {
                                country: country,
                                province: province[0],
                                zip: postcode
                            }];
                }
            });
        }); };
        this.getProductRecommendations = function (id, limit) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    fetch("/recommendations/products.json?product_id=" + id + "&limit=" + (limit ? limit : 4), {
                        credentials: "same-origin",
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            "Content-Type": "application/json;"
                        },
                        method: "GET"
                    })
                        .then(function (response) { return response.json(); })
                        .then(function (_a) {
                        var products = _a.products;
                        if (products.length > 0) {
                            _this.context.update({
                                recommendations: products,
                                message: "PRODUCT_RECOMMENDATIONS_SUCCESS"
                            });
                        }
                        else {
                            _this.context.update({
                                message: "PRODUCT_RECOMMENDATIONS_NOTFOUND"
                            });
                        }
                    });
                }
                catch (err) {
                    this.context.update({
                        message: "PRODUCT_RECOMMENDATIONS_FAILED",
                        error: err.message
                    });
                }
                return [2 /*return*/];
            });
        }); };
        this.toggleFreeShipping = function (event) { };
        this.toggleUpsells = function (event) { };
        this.toggleFreeGift = function (event) { };
        this.cart = cart;
    }
    return Cart;
}());
exports.Cart = Cart;
//# sourceMappingURL=cart.js.map